import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';

import { useGetProfileVisibility } from '../data';

import translations from './.vocab';

interface Props {
  loading?: boolean;
}

export const ProfileVisibilityStatus = ({ loading }: Props) => {
  const { t } = useTranslations(translations);
  const { profileVisibilityLevel } = useGetProfileVisibility();

  const profileVisibilityLevelText = {
    Hidden: t('Not searchable by employers'),
    Standard: t('Searchable by employers'),
    Limited: t('Searchable by employers'),
  };

  const id = `profile-visibility-status-${
    profileVisibilityLevel ? profileVisibilityLevel.toLowerCase() : 'not-set'
  }-txt`;

  return loading ? (
    <LoadingItem type="text" size="standard" width="large" />
  ) : (
    <Text
      id={id}
      data={{ automation: id }}
      tone={profileVisibilityLevel === null ? 'critical' : 'neutral'}
    >
      {profileVisibilityLevel
        ? profileVisibilityLevelText[profileVisibilityLevel]
        : t('Searchable by employers not set')}
    </Text>
  );
};
